import Action from "@/action/Action"
import ActionId from "@/action/ActionId"
import { accountService } from "@/service"
import router from "@/router"
import accountState from "@/state/AccountState"
import { providerState } from "@/state/index.js"

class ChangeCreditLimitAction extends Action {

    #providerKey = null
    #request = null

    constructor(providerKey, request) {
        super(ActionId.CHANGE_CREDIT_LIMIT)
        this.#providerKey = providerKey
        this.#request = request
    }

    async invoke() {
        const response = await accountService.changeCreditLimit(this.#providerKey, this.#request)
        if (response.responseCode.toLowerCase() === "success") {
            accountState.account.creditLimitCents = response.creditLimitCents
            accountState.account.availableAmountCents = response.availableAmountCents

            const preauthResponse = providerState.getPreAuthResponse(this.#providerKey)
            if (preauthResponse.existingAccount) {
                preauthResponse.approvedAmountCents = response.creditLimitCents
            }
        }
        accountState.account = {...accountState.account, creditLimitChangeResponse: response}
        await router.push({ path: `/providers/${this.#providerKey}/credit_limit_change/result` })
    }
}

export default ChangeCreditLimitAction
